module.exports = __webpack_public_path__ + "assets/c408e961a5f2ccd6508b69337eca4063.mp3";